<template>
    <div class="files-container">
        <header>
            <el-button size="medium" class="newFile" type="primary" @click="newFolder"><i class="el-icon-plus"></i><span>新建文件夹</span></el-button>
            <el-button size="medium" type="primary" class="edit" @click="editFolder" :disabled="chosenFolder == -1">编辑</el-button>
            <el-button size="medium" type="primary" class="delete" @click="deleteFolder" :disabled="chosenFolder == -1">删除</el-button>
        </header>
        <main @mouseenter="mouseEnter = true" @mouseleave="mouseEnter = false" ref="main">
            <div class="folder-box" ref="folderBox" style="position: relative">
                <div class="folder" @click="editAndDelete" v-for="item in folders" :key="item.id">
                    <el-collapse @change="() => {!item.isopening && queryFiles(item.id); item.isopening = true; isEditingFolder? '':chosenFolder = item.id;}">
                        <el-collapse-item name="1">
                            <template slot="title">
                                <div style="height: 100%; margin-left: -20px" :class="{isChosen: chosenFolder == item.id}"></div>
                                <div style="height: 100%; position: absolute; left: 0px; top: 0; padding-left: 38px">
                                    <span class="text" v-if="!isEditingFolder || chosenFolder != item.id">{{item.foldername | titleEncode}}</span>
                                    <div @click="e => e.stopPropagation()" style="display: inline-block; height: 50px" v-if="!isEditingFolder || chosenFolder != item.id">
                                        <el-upload
                                                class="upload-demo"
                                                action="/indexapp.php?c=FileManager&a=UploadUserFile"
                                                :data="{ id: id, folderid: item.id, name: fileName, filename: fileNameMd5 }"
                                                :http-request="uploadFile"
                                                :before-upload="beforeUpload"
                                                :show-file-list="false"
                                        >
                                            <i class='importCourseware'></i>
                                            <el-button size="small" type="primary"
                                                       style="height: 25px; width: 25px; padding: 0; position: absolute; top: 13px; left: 0; opacity: 0"></el-button>

                                        </el-upload>
                                    </div>
                                    <div class="editingFolderName" v-else @click="e => e.stopPropagation()">
                                        <el-input
                                                size="small"
                                                :value="item.foldername | titleEncode"
                                                @change="value => handleFolderChange(value, item.id)"
                                        >
                                        </el-input>
                                        <i class="saveTitle" @click="saveFolderEdit(item.id)"></i>
                                        <i class="cancelTitle" @click="cancelFolderEdit(item.id)"></i>
                                    </div>
                                </div>

                            </template>
                            <div :class="{row: true, editing: currentEdit == course.id && currentFolder == item.id}" v-for="(course,index) in files[item.id]" :key="course.id">
                                <div class="num"><span>{{index + 1}}</span></div>
                                <div class="title">
                                    <span v-if="currentEdit != course.id || currentFolder != item.id">{{course.filename | titleEncode}}</span>
                                    <div v-else>
                                        <el-input
                                                size="small"
                                                :value="course.filename | titleEncode"
                                                @change="value => handleCourseChange(value, course.id, item.id)"
                                        >
                                        </el-input>
                                        <i class="saveTitle" data-title="save" :data-folder-id="item.id" :data-id="course.id"></i>
                                        <i class="cancelTitle" data-title="cancel" :data-folder-id="item.id" :data-id="course.id"></i>
                                    </div>

                                </div>
                                <div class="time">{{course.updatetime}}</div>
                                <div class="operate">
                                    <i class="editCourseware" data-title="edit" :data-folder-id="item.id" :data-id="course.id"></i>
                                    <i class="deleteCourseware" data-title="delete" :data-folder-id="item.id" :data-id="course.id"></i>
                                </div>
                            </div>
                        </el-collapse-item>

                    </el-collapse>
                </div>
            </div>
<!--            <el-progress :percentage="100 * uploadPercent"></el-progress>-->
<!--            <div class="el-scrollbar__bar is-vertical" style="opacity: 1">-->
<!--                <div class="el-scrollbar__thumb" @mousedown="scrollBarMove" ref="scrollBar"-->
<!--                     style="height: 23.0873%; background-color: rgba(0,0,0,.9)"></div>-->
<!--            </div>-->
        </main>
    </div>
</template>

<script>
    import {saveLocal, loadLocal} from 'common/js/store.js';
    import md5 from 'js-md5';

    export default {
        name: "Files",
        data () {
            return {
                id: (() => loadLocal('id', false))(),
                error: null,
                currentEdit: -1,
                currentFolder: -1, //当前操作文件夹
                chosenFolder: -1, //当前选中文件夹
                cacheFolderName: {},
                isEditing: false,
                isEditingFolder: false,
                folders: [],
                files: {},
                cacheFiles: {},
                fileName: '',
                fileNameMd5: '',
                mouseEnter: false,
                folderBoxHeight: '',
                mainHeight: '',
                uploadPercent: 0
            }
        },
        created () {
            this.queryFolders()
        },
        methods: {

            //新建文件夹
            newFolder () {
                this.$prompt('文件夹名称:', '新建文件夹', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /^\S{1,10}$/,
                    inputErrorMessage: '文件夹名称必须在1到10个字符之间,且不能有空格',
                    center: true,
                    customClass: 'newFolderMessage'
                }).then(({ value }) => {
                    const params = {
                        id: this.id,
                        foldername: value
                    };
                    this.$http({
                        url: '/indexapp.php?c=FileManager&a=AddUserFolder',
                        method: 'GET',
                        params: params
                    })
                        .then((response) => {
                            const data = response.data;
                            if (data.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: '文件夹创建成功'
                                });
                                this.queryFolders();
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: '文件夹创建失败, 文件夹名称不能相同'
                                });
                            }
                        }).catch((err) => {

                    });

                }).catch(() => {

                });
            },

            //查询文件夹
            queryFolders () {
                const params = {
                    id: this.id,
                    pageno: 1,
                    pagesize: 100
                };
                this.$http({
                    url: '/indexapp.php?c=FileManager&a=QueryUserFolder',
                    method: 'GET',
                    params: params
                })
                    .then((response) => {
                        const data = response.data;
                        //console.log(data);
                        if (data.code === 200) {
                            let foldersArr = data.list;
                            foldersArr.forEach(item => {
                                item.isopening = false;
                                this.cacheFolderName[item.id] = item.foldername;
                            });
                            this.folders = foldersArr;
                        } else if (data.code === 101) {
                            this.folders = [];
                        }
                    })
                    .catch((err) => {

                    });
            },

            //删除文件夹
            deleteFolder () {
                this.$confirm('删除文件夹内部课件将会消失', '确认删除文件夹?', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    center: true,
                    customClass: 'deleteCourse'
                }).then(() => {
                    const params = {
                        id: this.id,
                        folderid: this.chosenFolder
                    };
                    this.$http({
                        url: '/indexapp.php?c=FileManager&a=DeleteUserFolder',
                        method: 'GET',
                        params: params
                    })
                        .then((response) => {
                            const data = response.data;
                            if (data.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: '文件夹删除成功'
                                });
                                this.queryFolders();
                                this.chosenFolder = -1;
                                this.isEditingFolder = false;
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: '文件夹删除失败'
                                });
                            }
                        }).catch((err) => {

                    });

                }).catch(() => {

                });
            },

            //编辑文件夹
            editFolder () {
                this.isEditingFolder = true;
            },

            //文件夹名称改变
            handleFolderChange (value, folderId) {
                const target = this.folders.filter(item => folderId === item.id)[0];
                if (target) {
                    target['foldername'] = value;
                }
            },

            //保存文件夹编辑
            saveFolderEdit (folderId) {
                const target = this.folders.filter(item => folderId === item.id)[0];
                const pattern = /^\S{1,10}$/;
                if (!pattern.test(target.foldername)) {
                    return  this.$message({
                        type: 'warning',
                        message: '文件夹名称不能超过10个字符,且不能有空格'
                    });
                }

                const params = {
                    id: this.id,
                    folderid: folderId,
                    foldername: target.foldername
                };
                this.$http({
                    url: '/indexapp.php?c=FileManager&a=UpdateUserFolder',
                    method: 'GET',
                    params: params
                })
                    .then((response) => {
                        const data = response.data;
                        if (data.code === 200) {
                            this.cacheFolderName[folderId] = target.foldername;
                            this.$message({
                                type: 'success',
                                message: '文件夹编辑成功'
                            });
                        } else {
                            this.$message({
                                type: 'error',
                                message: '文件夹编辑失败, 文件夹名称不能相同'
                            });
                        }
                    })
                    .catch((err) => {

                    });
                this.isEditingFolder = false;
            },

            //取消文件夹编辑
            cancelFolderEdit (folderId) {
                const target = this.folders.filter(item => folderId === item.id)[0];
                if (target) {
                    target.foldername = this.cacheFolderName[folderId];
                }
                this.isEditingFolder = false;
            },

            //查询用户文件
            queryFiles (folderId) {
                const params = {
                    id: this.id,
                    folderid: folderId,
                };
               // this.currentFolder = folderId;
                this.$http({
                    url: '/indexapp.php?c=FileManager&a=QueryUserFile',
                    method: 'GET',
                    params: params
                })
                    .then((response) => {
                        const data = response.data;
                        //console.log(data);
                        if (data.code === 200) {
                             // this.files[folderId] = data.list;
                            this.$set(this.files, folderId, data.list);
                            this.cacheFiles[folderId] = data.list.map(item => ({ ...item }));
                        } else if (data.code === 101) {
                            this.$message({
                                type: 'warning',
                                message: '您还没有添加课件'
                            });
                            this.$set(this.files, folderId, []);
                            this.cacheFiles[folderId] = [];
                        } else {
                            this.$message({
                                type: 'error',
                                message: '获取课件失败'
                            });
                        }
                    })
                    .catch((err) => {

                    });
            },

            //自定义上传
            uploadFile (item) {
                let data = new FormData();
                const file = item.file;
                data.append('file', file);
                data.append('id', this.id);
                data.append('folderid', item.data.folderid);
                data.append('name', file.name);
                data.append('filename', md5(file.name));
                //const xhr = new XMLHttpRequest();
                // xhr.open('post','/indexapp.php?c=FileManager&a=UploadUserFile');
                // xhr.send(data);
                // const that = this;
                // xhr.onload = function () {
                //     const res = JSON.parse(this.responseText);
                //     if (res.code === 200) {
                //         that.$message({
                //             type: 'success',
                //             message: '课件上传成功'
                //         });
                //         that.queryFiles(item.data.folderid,true);
                //     } else {
                //         that.$message({
                //             type: 'error',
                //             message: '课件上传失败'
                //         });
                //     }
                // };
                this.$http({
                    url: '/indexapp.php?c=FileManager&a=UploadUserFile',
                    method: 'POST',
                    data: data,
                    onUploadProgress: progressEvent => {
                        this.uploadPercent = progressEvent.loaded / progressEvent.total
                    },
                })
                    .then((response) => {
                        const data = response.data;
                        if (data.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '课件上传成功'
                            });
                            this.queryFiles(item.data.folderid,true);
                        } else {
                            this.$message({
                                type: 'error',
                                message: '课件上传失败'
                            });
                        }
                    })
                    .catch((err) => {

                    });
            },

            //课件上传验证
            beforeUpload (file) {
                // console.log(file);
                //const isJPG = file.type === 'image/jpeg';
                const isLt10M = file.size / 1024 / 1024 < 10;

                // if (!isJPG) {
                //     this.$message.error('上传头像图片只能是 JPG 格式!');
                // }
                if (!isLt10M) {
                    this.$message.error('上传的课件不能超过 10MB!');
                }
                return isLt10M
            },


            //课件编辑与删除判断
            editAndDelete (e) {
                const dataset = e.target.dataset;
                let title = dataset.title;
                let id = dataset.id;
                let folderId = dataset.folderId;
                if (title == 'edit') {
                    this.editCourseware(id, folderId)
                } else if (title == 'delete') {
                    this.deleteCourseware(id, folderId);
                }else if (title == 'save') {
                    this.saveEdited(id, folderId);
                }else if (title == 'cancel') {
                    this.cancelEdited(id, folderId);
                }
            },

            //课件编辑功能
            editCourseware (id, folderId) {
                if (this.isEditing) return;
                this.currentEdit = id;
                this.currentFolder = folderId;
                this.isEditing = true;
            },

            //课程重命名
            handleCourseChange (value, key, folderId) {
                const newData = [...this.files[folderId]];
                const target = newData.filter(item => key === item.id)[0];
                if (target) {
                    target['filename'] = value;
                    this.files[folderId] = newData;
                }
            },

            //保存编辑
            saveEdited (key, folderId) {
                const newData = [...this.files[folderId]];
                const target = newData.filter(item => key === item.id)[0];
                const params = {
                    id: this.id,
                    fileid: key,
                    filename: target.filename
                };
                this.isEditing = false;
                this.$http({
                    url: '/indexapp.php?c=FileManager&a=UpdateUserFile',
                    method: 'GET',
                    params: params
                })
                    .then((response) => {
                        const data = response.data;
                        //console.log(data);
                        if (data.code === 200) {
                            Object.assign(this.cacheFiles[folderId].filter(item => key === item.id)[0], target);
                            this.currentEdit = -1;
                            this.$message({
                                type: 'success',
                                message: '课件编辑成功'
                            });
                        } else {
                            this.$message({
                                type: 'error',
                                message: '课件编辑失败'
                            });
                        }
                    })
                    .catch((err) => {

                    });

            },

            //取消编辑
            cancelEdited (key, folderId) {
                const newData = [...this.files[folderId]];
                const target = newData.filter(item => key === item.id)[0];
                if (target) {
                    Object.assign(target, this.cacheFiles[folderId].filter(item => key === item.id)[0]);
                    this.files[folderId] = newData;
                }
                this.currentEdit = -1;
                this.isEditing = false;
            },

            //课件删除功能
            deleteCourseware (id, folderId) {
                this.$confirm('删除的课件将不能恢复', '确认删除课件?', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    center: true,
                    customClass: 'deleteCourse'
                }).then(({ value }) => {
                    const params = {
                        id: this.id,
                        fileids: id
                    };
                    this.$http({
                        url: '/indexapp.php?c=FileManager&a=DeleteUserFile',
                        method: 'GET',
                        params: params
                    })
                        .then((response) => {
                            const data = response.data;
                            //console.log(data);
                            if (data.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: '课件删除成功'
                                });
                                this.queryFiles(folderId,true);
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: '课件删除失败'
                                });
                            }
                        }).catch((err) => {

                            });

                }).catch(() => {

                });
            },

            //滚动条滚动
            // scrollBarMove (e) {
            //     console.log(e)
            //     const folderBox = this.$refs.folderBox;
            //     const presentY = e.clientY;
            //     const barHeight = e.target.offsetHeight;
            //     const barTop = e.target.offsetTop;
            //     const folderBoxTop = folderBox.offsetTop - 22;
            //     console.log(barTop, folderBoxTop);
            //     document.onmousemove =  (event) => {
            //         const currentY = event.clientY;
            //         let distanceY = currentY - presentY;
            //         let maxDistanceY = this.mainHeight - barHeight - barTop - 4;
            //         distanceY < -barTop ? distanceY = -barTop: distanceY;
            //         distanceY > maxDistanceY ? distanceY = maxDistanceY: distanceY;
            //         let folderBoxDistance = distanceY / (this.mainHeight -4) * this.folderBoxHeight;
            //
            //         e.target.style.top = barTop + distanceY + 'px';
            //         folderBox.style.top = -folderBoxDistance + folderBoxTop + 'px';
            //
            //         window.getSelection()?window.getSelection().removeAllRanges():document.selection.empty();
            //
            //     }
            // },
            //
            // //设置滚动条样式
            // setScrollBar () {
            //     const mainHeight = this.$refs.main.offsetHeight;
            //     const folderBoxHeight = this.$refs.folderBox.offsetHeight;
            //     this.mainHeight = mainHeight;
            //     this.folderBoxHeight = folderBoxHeight;
            //     this.$refs.scrollBar.style.height = mainHeight / (folderBoxHeight + 44) * 100 + '%';
            // },

        },
        filters: {
            //url转码
            titleEncode (value) {
                return decodeURI(value);
            },
        }
    }
</script>

<style>
    .newFolderMessage {
        width: 472px;
        height: 280px;
        padding: 0;
        box-sizing: border-box;
        border-radius: 12px;
    }
    .newFolderMessage .el-message-box__header {
        padding: 34px 0 0 76px;
    }
    .newFolderMessage .el-message-box__header .el-message-box__title {
        justify-content: start;
    }
    .newFolderMessage .el-message-box__header .el-message-box__title span {
        font-size: 32px;
        color: #333;
    }
    .newFolderMessage .el-message-box__content {
        display: flex;
        margin-top: 50px;
        padding: 0 0 0 76px;
    }
    .newFolderMessage .el-message-box__content p {
        height: 32px;
        line-height: 32px;
        font-size: 16px;
        color: #555;
        margin-right: 10px;
    }
    .newFolderMessage .el-message-box__content .el-message-box__input {
        height: 32px;
        padding: 0;
        text-align: left;
        width: 186px;
    }
    .newFolderMessage .el-message-box__content .el-message-box__input .el-input__inner {
        height: 32px;
        width: 186px;
        padding-left: 9px;
    }
    .newFolderMessage .el-message-box__btns {
        padding: 0;
        margin-top: 58px;
        text-align: left;
    }
    .newFolderMessage .el-message-box__btns button {
        width: 80px;
        font-size: 16px;
    }
    .newFolderMessage .el-message-box__btns button:first-of-type {
        margin: 0 66px 0 123px;
    }

    .deleteCourse {
        width: 440px;
        height: 224px;
        padding: 0;
        box-sizing: border-box;
        border-radius: 12px;
    }
    .deleteCourse .el-message-box__header {
        padding-top: 32px;
        padding-bottom: 0;
    }
    .deleteCourse .el-message-box__header .el-message-box__title span {
        font-size: 32px;
        color: #333;
    }
    .deleteCourse .el-message-box__content {
        margin-top: 20px;
        padding: 0;
    }
    .deleteCourse .el-message-box__content p {
        height: 28px;
        line-height: 28px;
        font-size: 24px;
        color: #555;
    }
    .deleteCourse .el-message-box__btns {
        padding: 0;
        margin-top: 40px;
        text-align: left;
    }
    .deleteCourse .el-message-box__btns button {
        width: 80px;
        font-size: 16px;
        height: 34px;
        margin-left: 0;
    }
    .deleteCourse .el-message-box__btns button:first-of-type {
        margin: 0 66px 0 107px;
    }
     .files-container {
        /*width: 100%;*/
        height: 100%;
        padding: 91px 0 0 160px;
        background-color: #f2f2f2;
        box-sizing: border-box;
         position: relative;
    }
    .files-container .el-upload--text {
        position: relative;
    }
    .files-container * {
        box-sizing: border-box;
    }
    .files-container header {
        height: 51px;
        width: 100%;
        padding: 8px 20px 8px;
        font-size: 0;
        background-color: #fff;
        box-sizing: border-box;
        border-bottom: 1px solid #c4c4c4;
        position: fixed;
        left: 160px;
        top: 40px;
    }
    .files-container header button {
        border: none;
        padding: 10.5px 23px;
        font-size: 12px;
        vertical-align: middle;
    }
    .files-container header .delete {
        margin: 0;
    }
    .files-container header .newFile {
        padding: 10px 34px 10px 15px ;
        width: 140px;
    }
    .files-container header .newFile > span i{
        font-size: 14px;
        margin-left: -20px;
    }
    .files-container header .newFile > span {
        display: inline-block;
        width: 91px;
        line-height: 14px;
    }
    .files-container header .newFile > span span{
        float: right;
        font-size: 12px;
        margin: 0;
    }
    .files-container header .edit {
        margin-left: 32px;
        margin-right: 20px;
    }
    .files-container main {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 22px 0 0 20px;
        overflow: auto;
        position: relative;
    }
    .files-container main .folder {
        border-radius: 7px;
        box-shadow: 0 2px 10px 0 rgba(0,0,0,.1);
        overflow: hidden;
        margin-bottom: 10px;
        width: 1166px;
    }
    .files-container .folder div {
        border: 0;
    }
    .files-container .folder .el-collapse .el-collapse-item__header {
        height: 50px;
        line-height: 50px;
        padding-left: 20px;
        font-size: 0;
    }
    .files-container .folder .el-collapse .text {
        float: left;
        margin: 0 20px;
        font-size: 16px;
        color: #202020;
    }
    .files-container .folder .el-collapse i {
        float: left;
        font-size: 20px;
        font-weight: 600;
        color: #999;
        margin-right: 0;
        height: 100%;
        line-height: 50px;
    }
    .files-container .folder .el-collapse .importCourseware {
        width: 25px;
        height: 25px;
        margin-top: 12.5px;
        display: inline-block;
        background: url("./images/上传.png") no-repeat center;
    }
    .files-container .folder .el-collapse .el-collapse-item__content {
        padding: 0;
    }
    .files-container .folder .el-collapse-item {
        background-color: #fff;
    }
    .files-container .folder .el-collapse-item .isChosen {
        background-color: #f0f8fd;
    }
    .files-container .folder .el-collapse-item .el-collapse-item__header {
        background-color: rgba(0,0,0,0);
        position: relative;
    }
    .files-container .folder .editingFolderName {
        display: inline-block;
        margin-left: 10px;
        height: 50px;
        padding: 10px 0;
    }
    .files-container .folder .editingFolderName .el-input {
        width: 200px;
        float: left;
        height: 30px;
        line-height: 30px;
        vertical-align: middle;
    }
    .files-container .folder .editingFolderName .saveTitle {
        width: 30px;
        height: 30px;
        display: inline-block;
        cursor: pointer;
        margin: 0 10px 0 12px;
        background-image: url("./images/save.png");
        background-size: cover;
    }
    .files-container .folder .editingFolderName .cancelTitle {
        width: 30px;
        height: 30px;
        display: inline-block;
        cursor: pointer;
        background-size: cover;
        background-image: url("./images/cancel.png");
    }
    .files-container .folder .editingFolderName input {
        padding-left: 9px;
        color: #202020;
        font-size: 16px;
        border: 1px solid #3399ff;
        width: 200px;
        height: 30px;
    }
    .files-container .folder .row {
        height: 50px;
        border-top: 2px solid #f2f2f2;
        display: flex;
        padding: 10px 0;
    }
    .files-container .folder .row.editing {
        background-color: #f0f8fd;
    }
    .files-container .folder .row .num {
        height: 100%;
        width: 126px;
        border-right: 4px solid #e5e5e5;
        text-align: center;
    }
    .files-container .folder .row .num span {
        display: inline-block;
        width: 25px;
        height: 25px;
        border-radius: 50%;
        background-color: #7d9fff;
        color: #fff;
        font-size: 16px;
        text-align: center;
        line-height: 25px;
    }
    .files-container .folder .row .title {
        width: 420px;
        padding-left: 34px;
        color: #202020;
        font-size: 16px;
        position: relative;
    }
    .files-container .folder .row .title > div {
        display: flex;
    }
    .files-container .folder .row .title .el-input {
        height: 30px;
        margin-left: -10px;
        width: 240px;
        margin-top: -2px;
    }
    .files-container .folder .row .title .saveTitle {
        width: 30px;
        height: 30px;
        display: inline-block;
        cursor: pointer;
        margin: -1px 10px 0 12px;
        background-image: url("./images/save.png");
        background-size: cover;
    }
    .files-container .folder .row .title .cancelTitle {
        width: 30px;
        height: 30px;
        display: inline-block;
        cursor: pointer;
        margin-top: -1px;
        background-size: cover;
        background-image: url("./images/cancel.png");
    }
    .files-container .folder .row .title input {
        padding-left: 9px;
        color: #202020;
        font-size: 16px;
        border: 1px solid #3399ff;
        width: 240px;
    }
    .files-container .folder .row .time {
        color: #202020;
        font-size: 16px;
        width: 480px;
    }
    .files-container .folder .row .operate {
        width: 140px;
        display: flex;
        justify-content: space-evenly;
    }
    .files-container .folder .row .operate .editCourseware {
        width: 25px;
        height: 25px;
        display: inline-block;
        cursor: pointer;
        background-image: url("./images/修改.png");
    }
    .files-container .folder .row .operate .deleteCourseware {
        width: 25px;
        height: 25px;
        display: inline-block;
        cursor: pointer;
        background-image: url("./images/删除.png");
    }
</style>


// WEBPACK FOOTER //
// src/page/files/Files.vue